export default {
  "pdf-preview-placeholder": "_pdf-preview-placeholder_1voptg"
};